module.exports = __webpack_public_path__ + "img/engine.ed67779f.svg";